import React from 'react';

const FAQ = (props) => (
  <svg
    viewBox="0 0 17.127 15.827"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <style>{`.faqIconClass{fill:currentColor;}`}</style>
    </defs>
    <g transform="translate(-1179.532 -21.231)">
      <rect
        rx="3.383"
        width="17.127"
        height="12.625"
        className="faqIconClass"
        transform="translate(1179.532 21.231)"
      />
      <path
        className="faqIconClass"
        d="M1182.227,32.185V36.4a.655.655,0,0,0,1.115.465l3.614-3.575"
      />
    </g>
  </svg>
);

export default FAQ;
